import type { Directive } from 'vue';
import { useAuthStore } from '@/stores/auth';

function checkPermission(el: HTMLElement, codes: string[]) {
  const auth = useAuthStore();
  const hasPermission = !codes || codes.length === 0 || auth.hasAnyPermission(...codes);
  el.style.display = hasPermission ? '' : 'none';
}

export const vPermission: Directive<HTMLElement, string[]> = {
  mounted(el, binding) { checkPermission(el, binding.value); },
  updated(el, binding) { checkPermission(el, binding.value); },
};

export function registerDirectives(app: import('vue').App) { app.directive('permission', vPermission); }
